import { Coding } from "@medplum/fhirtypes";

import { Answers, get } from "../utils";

const RELATIONSHIP_SELF_CODE = "1";

export function isClientInsuranceOwner(answers: Answers) {
  const relationshipWithSubscriber = get(
    answers[AnswersOptions.BillingInformationSubscriberRelationship],
  ) as Coding;

  return relationshipWithSubscriber?.code === RELATIONSHIP_SELF_CODE;
}

export function isClientSecondInsuranceOwner(answers: Answers) {
  const relationshipWithSubscriber = get(
    answers[AnswersOptions.BillingInformationSecondInsuranceSubscriberRelationship],
  ) as Coding;

  return relationshipWithSubscriber?.code === RELATIONSHIP_SELF_CODE;
}

export function isClientThirdInsuranceOwner(answers: Answers) {
  const relationshipWithSubscriber = get(
    answers[AnswersOptions.BillingInformationThirdInsuranceSubscriberRelationship],
  ) as Coding;

  return relationshipWithSubscriber?.code === RELATIONSHIP_SELF_CODE;
}

export enum AnswersOptions {
  BillingInformationPaymentMethod = "billingInformationPaymentMethod",
  BillingInformationHealthInsurance = "billingInformationHealthInsurance",
  BillingInformationInsuranceCompany = "billingInformationInsuranceCompany",
  BillingInformationInsuranceId = "billingInformationInsuranceId",
  BillingInformationInsuranceGroupNumber = "billingInformationInsuranceGroupNumber",
  BillingInformationSubscriberRelationship = "billingInformationSubscriberRelationship",
  BillingInformationSubscriberFirstName = "billingInformationSubscriberFirstName",
  BillingInformationSubscriberLastName = "billingInformationSubscriberLastName",
  BillingInformationSubscriberMiddleName = "billingInformationSubscriberMiddleName",
  BillingInformationSubscriberDateOfBirth = "billingInformationSubscriberDateOfBirth",
  BillingInformationSubscriberID = "billingInformationSubscriberID",
  BillingInformationSubscriberStreetAddress = "billingInformationSubscriberStreetAddress",
  BillingInformationSubscriberCity = "billingInformationSubscriberCity",
  BillingInformationSubscriberState = "billingInformationSubscriberState",
  BillingInformationSubscriberZipCode = "billingInformationSubscriberZipCode",
  BillingInformationAddress = "billingInformationAddress",
  BillingInformationCity = "billingInformationCity",
  BillingInformationState = "billingInformationState",
  BillingInformationZipCode = "billingInformationZipCode",
  BillingInformationPhone = "billingInformationPhone",
  BillingInformationType = "billingInformationType",
  BillingInformationCountry = "billingInformationCountry",
  BillingInformationAddressDetails = "billingInformationAddressDetails",
  BillingInformationStateMedicaidProgram = "billingInformationStateMedicaidProgram",
  BillingInformationSecondaryHealthInsurance = "billingInformationSecondaryHealthInsurance",
  BillingInformationThirdHealthInsurance = "billingInformationThirdHealthInsurance",
  BillingInformationReceiveWICAssistance = "billingInformationReceiveWICAssistance",
  BillingInformationInsuranceAndBillingComments = "billingInformationInsuranceAndBillingComments",
  BillingInformationSecondInsuranceCompany = "billingInformationSecondInsuranceCompany",
  BillingInformationSecondInsuranceId = "billingInformationSecondInsuranceId",
  BillingInformationSecondInsuranceGroupNumber = "billingInformationSecondInsuranceGroupNumber",
  BillingInformationSecondInsuranceSubscriberRelationship = "billingInformationSecondInsuranceSubscriberRelationship",
  BillingInformationSecondInsuranceSubscriberFirstName = "billingInformationSecondInsuranceSubscriberFirstName",
  BillingInformationSecondInsuranceSubscriberLastName = "billingInformationSecondInsuranceSubscriberLastName",
  BillingInformationSecondInsuranceSubscriberMiddleName = "billingInformationSecondInsuranceSubscriberMiddleName",
  BillingInformationSecondInsuranceSubscriberDateOfBirth = "billingInformationSecondInsuranceSubscriberDateOfBirth",
  BillingInformationSecondInsuranceSubscriberID = "billingInformationSecondInsuranceSubscriberID",
  BillingInformationSecondInsuranceSubscriberStreetAddress = "billingInformationSecondInsuranceSubscriberStreetAddress",
  BillingInformationSecondInsuranceSubscriberCity = "billingInformationSecondInsuranceSubscriberCity",
  BillingInformationSecondInsuranceSubscriberState = "billingInformationSecondInsuranceSubscriberState",
  BillingInformationSecondInsuranceSubscriberZipCode = "billingInformationSecondInsuranceSubscriberZipCode",
  BillingInformationSecondInsuranceAddress = "billingInformationSecondInsuranceAddress",
  BillingInformationSecondInsuranceCity = "billingInformationSecondInsuranceCity",
  BillingInformationSecondInsuranceState = "billingInformationSecondInsuranceState",
  BillingInformationSecondInsuranceZipCode = "billingInformationSecondInsuranceZipCode",
  BillingInformationSecondInsurancePhone = "billingInformationSecondInsurancePhone",
  BillingInformationSecondInsuranceType = "billingInformationSecondInsuranceType",
  BillingInformationSecondInsuranceCountry = "billingInformationSecondInsuranceCountry",
  BillingInformationSecondInsuranceAddressDetails = "billingInformationSecondInsuranceAddressDetails",
  BillingInformationThirdInsuranceCompany = "billingInformationThirdInsuranceCompany",
  BillingInformationThirdInsuranceId = "billingInformationThirdInsuranceId",
  BillingInformationThirdInsuranceGroupNumber = "billingInformationThirdInsuranceGroupNumber",
  BillingInformationThirdInsuranceSubscriberRelationship = "billingInformationThirdInsuranceSubscriberRelationship",
  BillingInformationThirdInsuranceSubscriberFirstName = "billingInformationThirdInsuranceSubscriberFirstName",
  BillingInformationThirdInsuranceSubscriberLastName = "billingInformationThirdInsuranceSubscriberLastName",
  BillingInformationThirdInsuranceSubscriberMiddleName = "billingInformationThirdInsuranceSubscriberMiddleName",
  BillingInformationThirdInsuranceSubscriberDateOfBirth = "billingInformationThirdInsuranceSubscriberDateOfBirth",
  BillingInformationThirdInsuranceSubscriberID = "billingInformationThirdInsuranceSubscriberID",
  BillingInformationThirdInsuranceSubscriberStreetAddress = "billingInformationThirdInsuranceSubscriberStreetAddress",
  BillingInformationThirdInsuranceSubscriberCity = "billingInformationThirdInsuranceSubscriberCity",
  BillingInformationThirdInsuranceSubscriberState = "billingInformationThirdInsuranceSubscriberState",
  BillingInformationThirdInsuranceSubscriberZipCode = "billingInformationThirdInsuranceSubscriberZipCode",
  BillingInformationThirdInsuranceAddress = "billingInformationThirdInsuranceAddress",
  BillingInformationThirdInsuranceCity = "billingInformationThirdInsuranceCity",
  BillingInformationThirdInsuranceState = "billingInformationThirdInsuranceState",
  BillingInformationThirdInsuranceZipCode = "billingInformationThirdInsuranceZipCode",
  BillingInformationThirdInsurancePhone = "billingInformationThirdInsurancePhone",
  BillingInformationThirdInsuranceType = "billingInformationThirdInsuranceType",
  BillingInformationThirdInsuranceCountry = "billingInformationThirdInsuranceCountry",
  BillingInformationThirdInsuranceAddressDetails = "billingInformationThirdInsuranceAddressDetails",
}
